import * as React from "react"

import { VISIBILITY_TRACKER_ROUTES } from "@constants"
import AppLayout from "Layout"
import MyTasksPage from "./index"


export const VtMyTasksRoutes = {
	path: VISIBILITY_TRACKER_ROUTES.MY_TASKS_PATH,
	title: VISIBILITY_TRACKER_ROUTES.MY_TASKS_TITLE,
	icon: 'list-check',
	iconWeight: 'light',
	element: <AppLayout />,
	description: VISIBILITY_TRACKER_ROUTES.SUBTITLE,
	// Access is handled in the page: vt_tagger and admin see it
	children: [{
		element: <MyTasksPage />,
		index: true
	}]
}
